import { Extension } from "@tiptap/core";

import { Store } from "@/store";

import { BubbleMenuPlugin, BubbleMenuPluginProps } from "./plugin";

export type BubbleMenuOptions = Omit<BubbleMenuPluginProps, "editor" | "element"> & {
  /**
   * The DOM element that contains your menu.
   * @type {HTMLElement}
   * @default null
   */
  element: HTMLElement | null;
};

export const BubbleMenu = Extension.create<BubbleMenuOptions>({
  name: "bubbleMenu",

  addOptions() {
    return {
      element: null,
      pluginKey: "bubbleMenu",
      hasActiveHighlight: () => Store.editor.activeHighlightGroup.value != null,
    };
  },

  addProseMirrorPlugins() {
    if (!this.options.element) {
      return [];
    }

    return [
      BubbleMenuPlugin({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        hasActiveHighlight: this.options.hasActiveHighlight,
      }),
    ];
  },
});
